"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vars = exports.default = exports.Storybook = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _reactJss = require("react-jss");
var _usehooksTs = require("usehooks-ts");
var _TextInput = require("./TextInput.util");
var _IconButton = _interopRequireDefault(require("../../components/IconButton"));
var _Text = require("../../components/Text/Text.util");
var _createUseStyles = _interopRequireDefault(require("../../themes/createUseStyles"));
var _Theme = require("../../themes/Theme");
var _defaultProps = _interopRequireDefault(require("../../utils/defaultProps"));
var _pickAndRemoveFromObject = _interopRequireDefault(require("../../utils/pickAndRemoveFromObject"));
var _commonProps = require("../../utils/vars/commonProps");
var _initVars = _interopRequireDefault(require("../../utils/vars/initVars"));
var _warning = _interopRequireDefault(require("../../utils/warning"));
var _excluded = ["id", "name", "disabled", "className", "errorText", "labelText", "labelFontSize", "labelTextTransform", "overrides", "textarea", "isValid", "onBlur", "onChange", "onKeyDown", "wrapperInput", "leftIcon", "rightIcon", "transparent", "hint", "description", "size", "wrapperProps", "prefix", "suffix", "rows", "type", "autoFocus", "max", "min"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; } /**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var common = ["width"].concat(_toConsumableArray(_commonProps.defaultCommonProps));
var vars = exports.vars = (0, _initVars.default)({
  applied: common,
  variables: [{
    key: "leftIconMarginTweak",
    defaultUnit: "px"
  }, {
    key: "leftIconInputTweak",
    defaultUnit: "px"
  }, {
    key: "inputDisabledAndPlaceholderColor",
    canHaveColor: true
  }, {
    key: "inputDisabledOpacity"
  }, {
    key: "transparentFilter"
  }, {
    key: "iconFillOnHover",
    canHaveColor: true
  }, {
    key: "labelFontSize",
    defaultUnit: "px"
  }, {
    key: "labelTextTransform"
  }]
});
var TextInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _classNames;
  var id = props.id,
    name = props.name,
    disabled = props.disabled,
    className = props.className,
    errorText = props.errorText,
    labelText = props.labelText,
    labelFontSize = props.labelFontSize,
    labelTextTransform = props.labelTextTransform,
    _props$overrides = props.overrides,
    overrides = _props$overrides === void 0 ? {} : _props$overrides,
    textarea = props.textarea,
    _props$isValid = props.isValid,
    isValid = _props$isValid === void 0 ? null : _props$isValid,
    onBlurProp = props.onBlur,
    onChangeProp = props.onChange,
    onKeyDownProp = props.onKeyDown,
    wrapperInput = props.wrapperInput,
    leftIcon = props.leftIcon,
    rightIcon = props.rightIcon,
    transparent = props.transparent,
    hint = props.hint,
    description = props.description,
    _props$size = props.size,
    size = _props$size === void 0 ? "medium" : _props$size,
    wrapperProps = props.wrapperProps,
    prefix = props.prefix,
    suffix = props.suffix,
    _props$rows = props.rows,
    rows = _props$rows === void 0 ? 10 : _props$rows,
    _props$type = props.type,
    type = _props$type === void 0 ? "text" : _props$type,
    _props$autoFocus = props.autoFocus,
    autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
    max = props.max,
    min = props.min,
    otherProps = _objectWithoutProperties(props, _excluded);
  var _useElementSize = (0, _usehooksTs.useElementSize)(),
    _useElementSize2 = _slicedToArray(_useElementSize, 2),
    leftIconRef = _useElementSize2[0],
    leftIconWidth = _useElementSize2[1].width;
  var theme = (0, _reactJss.useTheme)();
  var classes = useStyles(vars.useVars(_objectSpread({
    labelFontSize: labelFontSize,
    labelTextTransform: labelTextTransform,
    iconFillOnHover: transparent ? theme.colors.baseContrast100 : theme.colors.textOnLight,
    transparentFilter: theme.mode === _Theme.ThemeMode.light ? "invert(0)" : "invert(1)",
    inputDisabledOpacity: theme.mode === _Theme.ThemeMode.dark ? 0.5 : 1,
    inputDisabledAndPlaceholderColor: theme.mode === _Theme.ThemeMode.light ? theme.colors.baseContrast040 : theme.colors.baseContrast060,
    leftIconInputTweak: leftIconWidth + theme.spacing.base,
    leftIconMarginTweak: -leftIconWidth
  }, (0, _pickAndRemoveFromObject.default)(otherProps, common))));
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPassword = _useState2[0],
    setShowPassword = _useState2[1];
  var _useState3 = (0, _react.useState)(Boolean(otherProps.value)),
    _useState4 = _slicedToArray(_useState3, 2),
    hasValidStateShown = _useState4[0],
    setHasValidStateShown = _useState4[1];
  var InputComponent = textarea ? "textarea" : "input";
  var isPasswordType = type === "password";
  var calculatedType = isPasswordType ? showPassword ? "text" : "password" : type;
  process.env.NODE_ENV !== "production" ? (0, _warning.default)(name, "Always add the name prop to input components!") : void 0;
  var onBlur = function onBlur(e) {
    setHasValidStateShown(true);
    if (onBlurProp) {
      onBlurProp(e);
    }
  };
  var onChange = function onChange(e) {
    setHasValidStateShown(false);
    if (onChangeProp) {
      onChangeProp(e);
    }
  };
  var onKeyDown = function onKeyDown(e) {
    if (InputComponent === "input" && e.key === "Enter") {
      setHasValidStateShown(true);
    }
    if (onKeyDownProp) {
      onKeyDownProp(e);
    }
  };
  var handleClickShowPassword = function handleClickShowPassword() {
    return setShowPassword(function (show) {
      return !show;
    });
  };
  var isValidShowState = isValid === true && hasValidStateShown;
  var isInvalidShowState = (isValid === false || isValid === null && Boolean(errorText)) && hasValidStateShown;
  var isDefinedShowState = (isValid !== null || Boolean(errorText)) && hasValidStateShown;
  var showLeftIcon = leftIcon && !textarea;
  var showRightIcon = rightIcon && !isValidShowState && !isInvalidShowState && !textarea && !isPasswordType;
  var inputProps = _objectSpread(_objectSpread(_objectSpread({
    type: textarea ? undefined : calculatedType,
    rows: textarea ? rows : undefined,
    ref: ref,
    id: id !== null && id !== void 0 ? id : name,
    name: name,
    disabled: disabled,
    autoFocus: autoFocus,
    className: (0, _classnames.default)(classes.input, (_classNames = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, classes.inputWithValue, isDefinedShowState), classes.inputWithValuePassword, isPasswordType), classes.inputWithValidValue, !textarea && isValidShowState), classes.textareaWithValidValue, textarea && isValidShowState), classes.inputWithInvalidValue, !textarea && isInvalidShowState), classes.textareaWithInvalidValue, textarea && isInvalidShowState), classes.inputWithLeftIcon, showLeftIcon), classes.inputWithRightIcon, showRightIcon), classes.transparent, transparent), classes[size], !textarea), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_classNames, classes.textarea, textarea), classes.prefixPresent, prefix), classes.suffixPresent, suffix), classes.inputHasPrefix, prefix && (isValidShowState || isInvalidShowState)), classes.inputHasSuffix, suffix && (isValidShowState || isInvalidShowState)), classes.inputPrefixSuffixValid, !textarea && isValidShowState), classes.inputPrefixSuffixInvalid, !textarea && isInvalidShowState)), overrides === null || overrides === void 0 ? void 0 : overrides.input, className)
  }, (0, _TextInput.getRestrictedDate)(type, max, min)), otherProps), {}, {
    onBlur: onBlur,
    onChange: onChange,
    onKeyDown: onKeyDown
  });
  var ErrorElement = function ErrorElement() {
    if (!isInvalidShowState || !errorText) {
      return null;
    }
    var errorClasses = (0, _classnames.default)(classes.errorText, overrides.errorText);
    if (typeof errorText === "string") {
      return /*#__PURE__*/_react.default.createElement("p", {
        className: errorClasses
      }, errorText);
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: errorClasses
    }, errorText);
  };
  ErrorElement.displayName = "ErrorElement";
  return /*#__PURE__*/_react.default.createElement("span", _extends({}, wrapperProps, {
    className: (0, _classnames.default)(classes.variables, classes.root, overrides === null || overrides === void 0 ? void 0 : overrides.root, wrapperProps === null || wrapperProps === void 0 ? void 0 : wrapperProps.className)
  }), labelText && /*#__PURE__*/_react.default.createElement("label", {
    className: (0, _classnames.default)(classes.label, overrides === null || overrides === void 0 ? void 0 : overrides.label),
    htmlFor: inputProps.id
  }, /*#__PURE__*/_react.default.createElement("span", null, labelText), hint && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.hint)
  }, "\xA0(", hint, ")"), description && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(classes.description)
  }, description)), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, prefix && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.prefix, _defineProperty({}, classes.prefixValid, isValidShowState), _defineProperty({}, classes.prefixInvalid, isInvalidShowState), classes[size])
  }, prefix), showLeftIcon && /*#__PURE__*/_react.default.createElement("span", {
    ref: leftIconRef,
    className: (0, _classnames.default)(classes.leftIcon, _defineProperty({}, classes.disabledIcon, disabled))
  }, leftIcon), wrapperInput ? (/*#__PURE__*/(0, _react.cloneElement)(wrapperInput, _objectSpread({}, inputProps))) : /*#__PURE__*/_react.default.createElement(InputComponent, inputProps), !textarea &&
  /*#__PURE__*/
  // The span is only needed because input components have an animated top and bottom "border".
  // It plays when there is a change in the valid state, and wouldn't work on just one element.
  _react.default.createElement("span", {
    className: (0, _classnames.default)(classes.border, overrides === null || overrides === void 0 ? void 0 : overrides.border)
  }), showRightIcon && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.rightIcon, _defineProperty({}, classes.disabledIcon, disabled))
  }, rightIcon), suffix && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.suffix, _defineProperty({}, classes.suffixDefined, isValidShowState || isInvalidShowState), classes[size])
  }, suffix), isPasswordType && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)(classes.rightIcon, _defineProperty({}, classes.disabledIcon, disabled))
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    name: showPassword ? "visibilityOff" : "visibility",
    onClick: handleClickShowPassword
  }))), /*#__PURE__*/_react.default.createElement(ErrorElement, null));
});
var styles = function styles(theme) {
  return {
    variables: vars.styles,
    root: {
      display: "inline-flex",
      flexFlow: "column",
      width: "100%",
      fontFamily: theme.typography.fontFamily
    },
    input: {
      boxSizing: "border-box",
      background: theme.colors.textOnDark,
      padding: theme.spacing.base,
      fontSize: theme.typography.fontSize,
      WebkitAppearance: "none",
      outline: 0,
      color: theme.colors.textOnLight,
      borderStyle: "solid",
      borderRadius: 2,
      fontWeight: theme.typography.fontWeight,
      fontFamily: "inherit",
      position: "relative",
      transition: "300ms ease-in border-color",
      borderWidth: 1,
      borderColor: theme.colors.baseContrast060,
      width: "100%",
      height: "100%",
      "&:disabled": {
        background: theme.colors.baseContrast020,
        borderColor: theme.colors.baseContrast030,
        color: vars.get("inputDisabledAndPlaceholderColor"),
        opacity: vars.get("inputDisabledOpacity")
      },
      "&:disabled ~ span": {
        borderColor: theme.colors.baseContrast030,
        opacity: vars.get("inputDisabledOpacity")
      },
      "&::placeholder": {
        color: vars.get("inputDisabledAndPlaceholderColor")
      },
      "&:focus-visible": {
        boxShadow: "inset 0 0 2px 1px ".concat(theme.colors.baseInvariant)
      }
    },
    transparent: {
      background: "transparent",
      borderColor: theme.colors.baseContrast030,
      color: theme.colors.baseContrast070,
      "&::-webkit-calendar-picker-indicator": {
        filter: vars.get("transparentFilter")
      }
    },
    prefixPresent: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0
    },
    suffixPresent: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0
    },
    preAndSuffix: {
      backgroundColor: theme.mode === _Theme.ThemeMode.dark ? theme.colors.baseContrast085 : theme.colors.baseContrast015,
      color: theme.colors.textOnLight,
      border: "1px solid ".concat(theme.colors.baseContrast060),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      padding: "0 ".concat(theme.spacing.base * 1.5, "px")
    },
    prefix: {
      composes: "$preAndSuffix",
      borderEndStartRadius: "2px",
      borderStartStartRadius: "2px",
      borderInlineEnd: "none"
    },
    suffix: {
      composes: "$preAndSuffix",
      borderEndEndRadius: "2px",
      borderStartEndRadius: "2px",
      borderInlineStart: "none"
    },
    prefixSuffixValidity: {
      borderWidth: 2
    },
    prefixValid: {
      composes: "$prefixSuffixValidity",
      borderColor: theme.colors.success
    },
    prefixInvalid: {
      composes: "$prefixSuffixValidity",
      borderColor: theme.colors.alert
    },
    suffixDefined: {
      composes: "$prefixSuffixValidity"
    },
    border: {
      boxSizing: "border-box",
      position: "absolute",
      top: 0,
      // eslint-disable-next-line @atg/css-rtl-support
      left: 0,
      borderColor: theme.colors.baseContrast060,
      borderWidth: 2,
      borderStyle: "solid",
      borderRadius: 2,
      width: "100%",
      height: "100%",
      pointerEvents: "none",
      transform: "scaleX(0)",
      borderLeftWidth: 0,
      borderRightWidth: 0,
      transition: "500ms linear transform",
      transformOrigin: "center"
    },
    inputWithValue: {
      // we are extracting 1px to account for 2px border
      padding: [theme.spacing.base, theme.spacing.base - 1],
      borderWidth: 2,
      "& ~ span": {
        transform: "scaleX(1)"
      },
      "&:focus-visible ~ svg": {
        display: "inline-block"
      }
    },
    inputWithValuePassword: {
      paddingInlineEnd: theme.spacing.base * 5
    },
    inputWithValidValue: {
      borderLeftColor: theme.colors.success,
      borderRightColor: theme.colors.success,
      "& ~ span": {
        borderColor: theme.colors.success
      },
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    textareaWithValidValue: {
      borderColor: theme.colors.success,
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    inputWithInvalidValue: {
      borderLeftColor: theme.colors.alert,
      borderRightColor: theme.colors.alert,
      "& ~ span": {
        borderColor: theme.colors.alert
      },
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    textareaWithInvalidValue: {
      borderColor: theme.colors.alert,
      "&:focus-visible": {
        boxShadow: "none"
      }
    },
    inputWithLeftIcon: {
      paddingInlineStart: vars.get("leftIconInputTweak")
    },
    inputWithRightIcon: {
      paddingInlineEnd: theme.spacing.base * 5
    },
    label: {
      fontFamily: "inherit",
      fontSize: vars.get("labelFontSize", theme.typography.fontSize - 1),
      textTransform: vars.get("labelTextTransform", "none"),
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast060,
      paddingBottom: theme.spacing.base / 2,
      lineHeight: 1.4
    },
    errorText: _objectSpread({
      fontFamily: "inherit",
      marginTop: theme.spacing.base / 2,
      marginBottom: 0
    }, (0, _Text.setTextCssVars)({
      color: theme.colors.alert,
      fontSize: theme.typography.fontSize - 1,
      fontWeight: 600
    })),
    container: {
      alignItems: "center",
      display: "flex",
      position: "relative",
      "& > svg": {
        animation: "$StateIconFadeIn 700ms linear",
        cursor: "text",
        marginInlineStart: theme.spacing.base * -4,
        zIndex: 1
      }
    },
    icon: {
      zIndex: 2,
      "& :first-child": {
        maxHeight: theme.spacing.base * 4.5
      }
    },
    leftIcon: {
      extend: "icon",
      marginInlineEnd: vars.get("leftIconMarginTweak"),
      "& > *": {
        marginInlineStart: "".concat(theme.spacing.base, "px !important")
      }
    },
    rightIcon: {
      extend: "icon",
      marginInlineStart: -(theme.spacing.base * 5),
      "& svg": {
        fill: theme.colors.baseContrast050
      },
      "& [type='button'] svg": {
        fill: theme.colors.primary
      },
      "& [type='button']:hover svg": {
        fill: theme.colors.primaryDark
      },
      "&:hover svg": {
        fill: vars.get("iconFillOnHover")
      }
    },
    disabledIcon: {
      pointerEvents: "none",
      cursor: "default",
      borderColor: theme.colors.baseContrast030,
      "& svg, & [type='button'] svg": {
        fill: theme.colors.baseContrast030
      }
    },
    "@keyframes StateIconFadeIn": {
      "0%": {
        opacity: 0
      },
      "100%": {
        opacity: 100
      }
    },
    hint: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    description: {
      fontSize: theme.typography.fontSize - 2,
      fontWeight: theme.typography.fontWeight,
      color: theme.colors.baseContrast050
    },
    small: {
      height: 36
    },
    medium: {
      height: 40
    },
    large: {
      height: 48
    },
    textarea: {
      height: "auto"
    },
    // with prefix the border side is shifted to the prefix from the input side
    inputHasPrefix: {
      borderInlineStartColor: theme.colors.baseContrast060,
      borderInlineStartWidth: 1
    },
    // with suffix the border side is shifted to the suffix from the input side
    inputHasSuffix: {
      borderInlineEndColor: theme.colors.baseContrast060,
      borderInlineEndWidth: 1
    },
    inputPrefixSuffixValid: {},
    inputPrefixSuffixInvalid: {}
  };
};
var useStyles = (0, _createUseStyles.default)(styles, {
  name: "TextInput"
});
TextInput.displayName = "TextInput";
var Storybook = exports.Storybook = TextInput;

/**
 * @see https://icfreactcomponents.integ.icfsys.com/?path=/docs/form-textinput--docs
 */
var exportedComponent = (0, _defaultProps.default)(TextInput);
exportedComponent.displayName = "TextInput";
var _default = exports.default = exportedComponent;